import {
  CLOSE_CANCEL_ORDER_ALERT,
  CANCEL_ORDER,
  SET_OTHER_REASON, SET_SELECTED_REASON,
  OPEN_CANCEL_ORDER_DIALOG, CLOSE_CANCEL_ORDER_DIALOG,
  FETCH_ORDER_CLOSURE_REASONS,
} from 'constants/ActionTypes';

export const fetchOrderClosureReasons = () => ({ type: FETCH_ORDER_CLOSURE_REASONS });

export const openCancelOrderDialog = (reportId, reportAddress) => ({
  type: OPEN_CANCEL_ORDER_DIALOG,
  cancelReportID: reportId,
  cancelReportAddress: reportAddress,
});

export const closeCancelOrderDialog = () => ({ type: CLOSE_CANCEL_ORDER_DIALOG });

export const setSelectedReason = (selectedReason) => ({ type: SET_SELECTED_REASON, selectedReason });
export const setOtherReason = (otherReason) => ({ type: SET_OTHER_REASON, otherReason });

export const cancelOrder = (requestBody) => ({ type: CANCEL_ORDER, requestBody });

export const closeCancelOrderAlert = () => ({ type: CLOSE_CANCEL_ORDER_ALERT });
